export const INDUCT_MANAGEMENT_FIELDS = ["assignedNode", "forceInductStatus", "activeUntilMillis"]

export const FORCE_INDUCT_FIELDS = ["status","updatedBy"]

export const IS_USER_PERMITTED = "isUserPermitted";
export const ACCOUNT_ID = {
    JP_AMZL_ROOT: "AJGZQ6KPMOFMJ",
    AMZN_UK: "A1RFMHSF0CZ9W2",
    US_ROOT: "A1OGQG95VEURM9"
}
export const REGION = {
    US: "US",
    FE: "FE",
    EU: "EU"
}

export const FORCE_STATUS = {
    AUTOMATED: "AUTOMATED",
    ENABLED: "ENABLED",
    DISABLED: "DISABLED",
}

export const SORTATION_TYPE = {
    SORT_TO_ZONE: "SORT_TO_ZONE",
    SORT_TO_ROUTE: "SORT_TO_ROUTE"
}

export const DWC_ACTIONS = {
    LOAD_VIEW: "LOAD_VIEW",
    SAVE_CONFIG: "SAVE_CONFIG",
    ADD_CYCLE: "ADD_CYCLE",
    REMOVE_CYCLE: "REMOVE_CYCLE",
    ADD_WINDOW: "ADD_WINDOW",
    REMOVE_WINDOW: "REMOVE_WINDOW",
    RECEIVE_DATA: "RECEIVE_DATA",
    SET_VALUE: "SET_VALUE",
    SET_ALERT: "SET_ALERT",
    CLEAR_ALERT: "CLEAR_ALERT",
    EDIT_ACCESS: "EDIT_ACCESS"
}

export const AMAZON_SUFFIX = "@amazon.com";
export const DEFAULT_HOUR = 4

export const HOUR_OPTIONS = {
    "1 hour" : 1,
    "2 hours" : 2,
    "3 hours" : 3,
    "4 hours" : 4,
    "5 hours" : 5,
    "6 hours" : 6,
    "7 hours" : 7,
    "8 hours" : 8,
    "9 hours" : 9,
    "10 hours" : 10,
    "11 hours" : 11,
    "12 hours" : 12,
}

export const DEFAULT_ALERT = {id: "", default:"", values: {}, type: "error"}

export const DEFAULT_TIME_WINDOW = {startTimeString: "", endTimeString: ""}

export const EMPTY_STRING_PLACEHOLDER = "-"

export const CORE_CYCLE_PREFIX = "CYCLE_"

export const NONNULL_PLANNED_CYCLE_FIELD = ["cycleID", "cycleName", "sortationType"]

export const CYCLE_TYPE = ["DYNAMIC", "SORT_TO_ROUTE"]

export const DELIVERY_WINDOW_CONFIG_ALERTS = {
    GET_CONFIG_FAIL: {
        id: "inductmanagement.getConfigFail",
        default: "Encountered an error while trying to retrieve package cycle configuration",
        values: {},
        type: "error"
    },
    SET_CONFIG_FAIL: {
        id: "inductmanagement.setConfigFail",
        default: "Encountered an error while trying to set package cycle configuration",
        values: {},
        type: "error"
    },
    NO_WINDOWS: {
        id: "inductmanagement.noWindowsConfigured",
        default: "No scheduled delivery windows configured. Press edit to add new windows",
        values: {},
        type: "informational"
    },
    NO_CYCLES: {
        id: "inductmanagement.noCyclesPresent",
        default: "No cycles have been configured for this station. Please set up cycles before proceeding to delivery window configuration.",
        values: {},
        type: "warning"
    },
    NOT_ENABLED: {
        id: "inductmanagement.notEnabled",
        default: "Scheduled delivery window configuration tab has not been enabled for your station",
        values: {},
        type: "informational"
    },
    SAVE_SUCCESS: {
        id: "inductmanagement.saveSuccess",
        default: "Configuration change sent successfully. Changes may take up to 60 minutes to be applicable for incoming scheduled delivery packages",
        values: {},
        type: "success"
    }
}

export const FORCE_INDUCT_ALERTS = {
    NOT_ENABLED: {
        id: "inductmanagement.parallelNotEnabled",
        default: "Parallel induct tab has not been enabled for your station",
        values: {},
        type: "informational"
    }
}


// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/Constants.js